<template>
  <!-- TODO сделать лоадер -->
  <div v-if="!isFetched" class="ww-full flex items-center justify-center">
    Идёт загрузка...
  </div>
  <div
    v-else
    :class="isReportPresentation && 'flex items-center justify-center flex-col'"
  >
    <FailedPresentation
      v-if="errorMessage"
      :errorMessage="errorMessage"
      class="ww-full flex items-center justify-center"
    />
    <Presentation
      v-else-if="isStandardPresentation"
      :version="pugConfig.version"
      :renderParams="renderParams"
      :localeService="localeService"
    />
    <Report
      v-else-if="isReportPresentation"
      id="root"
      :domain="pugConfig.domain"
      :leads="renderParams.leads"
      :renderParams="renderParams"
      :localeService="localeService"
    />
  </div>
</template>

<script>
import { ref } from 'vue'
import FailedPresentation from './FailedPresentation.vue'
import Presentation from './Presentation/Presentation.vue'
import Report from './Report/Report.vue'
import Locale from '../services/locale.js'
import Api from '../services/api.js'
// import axios from 'axios'

const prepareAmoSettingsValue = (settings, cfs, settingType) => {
  try {
    const placeholders = {
      phone: 'номер агента',
      email: 'e-mail агента',
    }
    const placeholder = placeholders[settingType]
    const type = settings?.schemaType
    if (!['static', 'field'].includes(type)) return
    if (type === 'static') return settings.static
    const { fieldId } = settings
    const candidateCf = cfs.find((cf) => cf.field_id === fieldId)
    let rawValue = candidateCf?.values[0].value || ''
    rawValue = rawValue.trim().toLowerCase()
    if (candidateCf?.field_type === 'text') return rawValue
    if (!placeholder || rawValue === placeholder) return
    // eslint-disable-next-line no-unused-vars
    const [name, value] = rawValue.split('|') || []
    return value?.trim() || ''
  } catch (e) {
    console.log(e)
  }
}

export default {
  name: 'App',
  components: {
    FailedPresentation,
    Presentation,
    Report,
  },
  computed: {
    isReportPresentation() {
      return this.renderParams?.config?.version === 'report'
    },
    isStandardPresentation() {
      return this.renderParams?.config.version === 'standard'
    },
  },
  methods: {
    getConfigFromPug() {
      return JSON.parse(document.querySelector('#ww-data').dataset.config)
    },
    prepareAgent(agent, config, firstLead) {
      if (!agent) return
      const { phones: phoneSettings, email: emailSettings } = config
      let { phone_number: phone, login: email } = agent
      const cfs = firstLead?.custom_fields_values || []

      const preparedPhone = prepareAmoSettingsValue(phoneSettings, cfs, 'phone')
      if (preparedPhone) {
        phone = preparedPhone
      }

      const preparedEmail = prepareAmoSettingsValue(emailSettings, cfs, 'email')
      if (preparedEmail) {
        email = preparedEmail
      }

      return {
        name: agent.name,
        phone,
        photo: agent.photo_url,
        email,
        id: agent.id,
      }
    },
  },
  setup() {
    const pugConfig = ref({})
    const localeService = ref(Locale)
    const isFetched = ref(false)
    const renderParams = ref({
      agency: 'Презентация объекта',
    })

    return {
      pugConfig,
      isFetched,
      localeService,
      renderParams,
      errorMessage: '',
    }
  },
  async mounted() {
    this.pugConfig = this.getConfigFromPug()
    const { domain, managerId, pId, ids } = this.pugConfig

    const presentations = await Api.getPresentation({
      domain,
      managerId,
      pId,
      ids,
    }).catch((e) => {
      console.error(e)
      this.errorMessage = e.response.data?.message || e.message
    })

    if (!presentations) {
      this.isFetched = true
      return
    }

    const { config, leads } = presentations
    const hidingFieldsConfig = await Api.getHidingFieldsConfig(domain)
    const locale = await Api.getPresentationLocale({
      domain,
      localeId: config?.localId,
    })
    const currencyDict = await Api.getCurrencyDict()

    const agent = this.prepareAgent(presentations.agent, config, leads[0])

    this.renderParams = {
      yakey: this.pugConfig.yakey,
      config,
      hidingFieldsConfig,
      date: presentations.dateFormat,
      map: presentations.addresses,
      currency: presentations.currency,
      agency: presentations.agency,
      agent,
      infrastructure: presentations.isInfrastructure,
      leads,
      optionsNames: presentations.optionsNames,
      pId: presentations.pId,
      logoHost: config.imagesHost?.replace(
        `${config.domain}/`,
        `getSystemImg.php?img=logo&domain=${config.domain}`,
      ),
      currencyDict,
    }

    if (window.Telegram) {
      try {
        const tg = window.Telegram
        // TODO восстановить работу, когда будет готов сервер

        // const tgHost = 'http://localhost:3064'
        tg.WebApp.ready()
        // const initialData = tg.WebApp.initDataUnsafe
        // const { query_id: queryId, user } = initialData
        // const { query_id: queryId } = initialData
        // const url = new URL(location.href)
        // const botId = url.searchParams.get('botId')
        // const leadId = presentations.leads?.[0].id
        // const openEvent = {
        //   type: 'open-presentation',
        // }
        // const closeEvent = {
        //   type: 'close-presentation',
        // }
        // const commonEvent = {
        //   queryId,
        //   user: {
        //     firstName: user.first_name,
        //     lastName: user.last_name,
        //     userName: user.username,
        //   },
        //   objectId: leadId,
        //   domain: config.domain,
        // }
        // await axios
        //   .post(`${tgHost}/api/catalog/webapp`, {
        //     ...commonEvent,
        //     ...openEvent,
        //   })
        //   .then(console.log)
        // await axios.post(`${tgHost}/api/catalog/webapp`, {
        //   ...commonEvent,
        //   ...closeEvent,
        // })

        // const eventSource = new EventSource(
        //   `${tgHost}/api/catalog/webapp?queryId=${queryId}&botId=${botId}`,
        // )
        // eventSource.addEventListener('end-of-stream', () => {
        //   eventSource.close()
        // })
        // eventSource.onerror = (e) => {
        //   console.error(e)
        //   eventSource.close()
        // }
      } catch (e) {
        console.error(e)
      }
    }

    this.localeService = new Locale(locale)
    this.isFetched = true
  },
}
</script>

<style>
@import './../assets/tailwind.css';
</style>

<style scoped>
.ww-full {
  width: 100vw;
  height: 100vh;
}
</style>
